module.exports = __webpack_public_path__ + "static/media/background.0c9afdf8.png";